import { render, staticRenderFns } from "./CultureAssetMaintainInfo.vue?vue&type=template&id=3599caab&scoped=true&"
import script from "./CultureAssetMaintainInfo.vue?vue&type=script&lang=js&"
export * from "./CultureAssetMaintainInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3599caab",
  null
  
)

export default component.exports